export const PASSWORD_MIN_LENGTH = 8

export const isPasswordValid = (password: string): boolean => {
  return password.length >= PASSWORD_MIN_LENGTH
}
